import React from "react";
import ReactECharts from "echarts-for-react";
import { useTheme } from "@mui/material/styles";
import NoDataText from "../NoDataText/NoDataText";
const CrossCharts = ({ data, xAxisLabel, yAxisLabels, seriesConfig }) => {
	const theme = useTheme();

	if (!data || data.length === 0) {
		return <NoDataText />;
	}

	const options = {
		tooltip: {
			trigger: "axis",
		},
		xAxis: {
			type: "category",
			data: data.map((item) => item[xAxisLabel]),
		},
		yAxis: yAxisLabels.map((label, index) => ({
			type: "value",
			name: label,
			position: index === 0 ? "left" : "right",
		})),
		legend: {
			orient: "horizontal",
			left: "center",
			// top: "top",
			bottom: "bottom",
		},
		series: seriesConfig.map((config, index) => ({
			name: config.name,
			type: config.type,
			yAxisIndex: index, // Ensure correct yAxis index
			data: data.map((item) => item[config.dataKey]),
			itemStyle: config.itemStyle || {
				color: index === 0 ? theme.palette.primary.light : theme.palette.secondary.light,
			},
			lineStyle: config.lineStyle || {
				width: 3,
				type: "solid",
				color: theme.palette.secondary.light,
			},
			smooth: config.smooth || false,
		})),
	};

	return <ReactECharts option={options} style={{ height: "100%", width: "100%" }} />;
};

export default CrossCharts;
